"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _fastaToJson = _interopRequireDefault(require("./fastaToJson"));

var _genbankToJson = _interopRequireDefault(require("./genbankToJson"));

var _sbolXmlToJson = _interopRequireDefault(require("./sbolXmlToJson"));

var _extractFileExtension = _interopRequireDefault(require("./utils/extractFileExtension.js"));

var _snapgeneToJson = _interopRequireDefault(require("./snapgeneToJson"));

var _ab1ToJson = _interopRequireDefault(require("./ab1ToJson"));

var _gffToJson = _interopRequireDefault(require("./gffToJson"));

var _isBrowser = _interopRequireDefault(require("./utils/isBrowser"));

var _veSequenceUtils = require("ve-sequence-utils");

var _geneiousXmlToJson = _interopRequireDefault(require("./geneiousXmlToJson"));

var _fflate = require("fflate");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

/**
 * takes in file content string and its file name and determines what parser it needs to be sent to.
 * The file is parsed to our old JSON schema and after it goes through an intermediate step where we convert that json to our new schema
 * @param  {string} fileContentString content of the file as a string
 * @param  {Function} onFileParsed    //tnr: fill this out
 */
function anyToJson(_x, _x2) {
  return _anyToJson.apply(this, arguments);
}

function _anyToJson() {
  _anyToJson = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileContentStringOrFileObj, options) {
    var fileContentString, fileName, ext, a, b, c, d, failure, cleaned, parsersToTry, firstChar, _loop, _iterator, _step, _ret, successfulParsing;

    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            successfulParsing = function _successfulParsing(resultArray) {
              return resultArray.some(function (result) {
                return result.success;
              });
            };

            options = options || {};
            fileName = options.fileName || "";

            if (!fileName && typeof fileContentStringOrFileObj !== "string") {
              fileName = fileContentStringOrFileObj.name;
              options.fileName = fileName;
            }

            ext = (0, _extractFileExtension["default"])(fileName);

            if (!(typeof fileContentStringOrFileObj === "string")) {
              _context2.next = 9;
              break;
            }

            fileContentString = fileContentStringOrFileObj;
            _context2.next = 34;
            break;

          case 9:
            if (!/^(ab1)$/.test(ext)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", (0, _ab1ToJson["default"])(fileContentStringOrFileObj, options));

          case 13:
            if (!/^(prot)$/.test(ext)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", (0, _snapgeneToJson["default"])(fileContentStringOrFileObj, options));

          case 17:
            if (!/^(dna)$/.test(ext)) {
              _context2.next = 21;
              break;
            }

            return _context2.abrupt("return", (0, _snapgeneToJson["default"])(fileContentStringOrFileObj, options));

          case 21:
            if (!/^(geneious)$/.test(ext)) {
              _context2.next = 31;
              break;
            }

            _context2.next = 24;
            return getUint8ArrayFromFile(fileContentStringOrFileObj);

          case 24:
            a = _context2.sent;
            b = (0, _fflate.unzipSync)(a);
            c = Object.values(b)[0];
            d = new TextDecoder().decode(c, {
              stream: false
            });
            return _context2.abrupt("return", (0, _geneiousXmlToJson["default"])(d, options));

          case 31:
            _context2.next = 33;
            return getUtf8StringFromFile(fileContentStringOrFileObj, options);

          case 33:
            fileContentString = _context2.sent;

          case 34:
            if (!/^(fasta|fas|fa|fna|ffn)$/.test(ext)) {
              _context2.next = 38;
              break;
            }

            return _context2.abrupt("return", (0, _fastaToJson["default"])(fileContentString, options));

          case 38:
            if (!/^(gb|gbk)$/.test(ext)) {
              _context2.next = 42;
              break;
            }

            return _context2.abrupt("return", (0, _genbankToJson["default"])(fileContentString, options));

          case 42:
            if (!/^(json)$/.test(ext)) {
              _context2.next = 57;
              break;
            }

            // GENBANK
            failure = {
              messages: ["Unable to parse JSON file " + fileName],
              success: false
            };
            _context2.prev = 44;
            cleaned = (0, _veSequenceUtils.tidyUpSequenceData)(JSON.parse(fileContentString), options);

            if (cleaned.sequence.length) {
              _context2.next = 48;
              break;
            }

            return _context2.abrupt("return", [failure]);

          case 48:
            return _context2.abrupt("return", [{
              parsedSequence: cleaned,
              success: true
            }]);

          case 51:
            _context2.prev = 51;
            _context2.t0 = _context2["catch"](44);
            console.error("error:", _context2.t0);
            return _context2.abrupt("return", [failure]);

          case 55:
            _context2.next = 82;
            break;

          case 57:
            if (!/^(gp|genpep)$/.test(ext)) {
              _context2.next = 61;
              break;
            }

            return _context2.abrupt("return", (0, _genbankToJson["default"])(fileContentString, _extends({}, options, {
              isProtein: true
            })));

          case 61:
            if (!/^(xml|rdf)$/.test(ext)) {
              _context2.next = 65;
              break;
            }

            return _context2.abrupt("return", (0, _sbolXmlToJson["default"])(fileContentStringOrFileObj, options));

          case 65:
            if (!/^(gff|gff3)$/.test(ext)) {
              _context2.next = 69;
              break;
            }

            return _context2.abrupt("return", (0, _gffToJson["default"])(fileContentStringOrFileObj, options));

          case 69:
            // console.warn(
            //   "TNR: No filename passed to anyToJson so we're going through the list of parsers. Make sure you're passing the filename when using anyToJson!"
            // );
            parsersToTry = [{
              fn: _genbankToJson["default"],
              name: "Genbank Parser"
            }, {
              fn: _fastaToJson["default"],
              name: "Fasta Parser"
            }];
            firstChar = fileContentString[fileContentString.search(/\S|$/)]; //try to guess the file type based on the first non-whitespace char in the filestring

            if (firstChar === ">") {
              parsersToTry = parsersToTry.sort(function (a, b) {
                if (a.name === "Fasta Parser") return -1;
                return 1;
              });
            } else if (firstChar === "L") {
              parsersToTry = parsersToTry.sort(function (a, b) {
                if (a.name === "Genbank Parser") return -1;
                return 1;
              });
            }

            _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
              var parser, toReturn;
              return _regeneratorRuntime().wrap(function _loop$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      parser = _step.value;
                      _context.next = 3;
                      return parser.fn(fileContentString, options);

                    case 3:
                      toReturn = _context.sent;

                      if (!successfulParsing(toReturn)) {
                        _context.next = 7;
                        break;
                      }

                      //continue on to through the normal flow
                      toReturn.forEach(function (result) {
                        result.messages.push("Parsed using " + parser.name + ".");
                      });
                      return _context.abrupt("return", {
                        v: toReturn
                      });

                    case 7:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _loop);
            });
            _iterator = _createForOfIteratorHelperLoose(parsersToTry);

          case 74:
            if ((_step = _iterator()).done) {
              _context2.next = 81;
              break;
            }

            return _context2.delegateYield(_loop(), "t1", 76);

          case 76:
            _ret = _context2.t1;

            if (!(typeof _ret === "object")) {
              _context2.next = 79;
              break;
            }

            return _context2.abrupt("return", _ret.v);

          case 79:
            _context2.next = 74;
            break;

          case 81:
            return _context2.abrupt("return", [{
              messages: ["Unable to parse .seq file as FASTA, genbank, JBEI, or SBOL formats"],
              success: false
            }]);

          case 82:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[44, 51]]);
  }));
  return _anyToJson.apply(this, arguments);
}

var _default = anyToJson;
exports["default"] = _default;

function getUtf8StringFromFile(file, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      emulateBrowser = _ref.emulateBrowser;

  if (!_isBrowser["default"] && !emulateBrowser) {
    //emulate browser is only used for testing purposes
    //we're in a node context
    return Buffer.isBuffer(file) ? file.toString("utf-8") : Buffer.isBuffer(file.buffer) ? file.buffer.toString("utf-8") : file;
  }

  var reader = new window.FileReader();
  reader.readAsText(file, "UTF-8");
  return new Promise(function (resolve, reject) {
    reader.onload = function (evt) {
      resolve(evt.target.result);
    };

    reader.onerror = function (err) {
      console.error("err:", err);
      reject(err);
    };
  });
}

function getUint8ArrayFromFile(file, _temp2) {
  var _ref2 = _temp2 === void 0 ? {} : _temp2,
      emulateBrowser = _ref2.emulateBrowser;

  if (!_isBrowser["default"] && !emulateBrowser) {
    //emulate browser is only used for testing purposes
    //we're in a node context
    return Buffer.isBuffer(file) ? new Uint8Array(file) : Buffer.isBuffer(file.buffer) ? new Uint8Array(file.buffer) : file;
  }

  var reader = new window.FileReader(); // reader.readAsText(file, "UTF-8");

  reader.readAsArrayBuffer(file);
  return new Promise(function (resolve, reject) {
    reader.onload = function (evt) {
      var arrayBuffer = evt.target.result;
      var bytes = new Uint8Array(arrayBuffer);
      resolve(bytes);
    };

    reader.onerror = function (err) {
      console.error("err:", err);
      reject(err);
    };
  });
}

module.exports = exports.default;